import type { ISwiper, TDigestProducts } from '../../definitions'

import { String } from 'stdlib/String'

import DOM from '@common/DOM/DOM'

const PRODUCT_WIDTH = 264

/**
 * Termékek megjelenítése swiperben.
 * @param selector - A megadott section selector.
 * @param products - A termékek adatai.
 */
export default async function renderProducts (selector: string, products: TDigestProducts): Promise<void> {
  await DOM.createScript('https://cdn.jsdelivr.net/npm/swiper@11/swiper-element-bundle.min.js')

  const section = document.body.querySelector(selector)

  if (!section) {
    return
  }

  const template = section.querySelector('template#product-template')

  if (!template) {
    return
  }

  const swiper = section.querySelector<ISwiper>('swiper-container')

  if (!swiper) {
    return
  }

  const fragment = document.createDocumentFragment()

  const visibleProductsCount = Math.ceil(window.innerWidth / PRODUCT_WIDTH)

  products.forEach((product, i) => {
    const productElement = document.createElement('swiper-slide')

    productElement.classList.add('product')

    productElement.innerHTML = template.innerHTML

    // A termékhez tartozó kép elem
    const image = productElement.querySelector<HTMLImageElement>('img.product__image')

    if (image && product.images[0]) {
      const isLazy = i > visibleProductsCount

      image.src = `https://wsrv.nl?output=webp&h=175&w=225&url=${ product.images[0] }`
      image.alt = product.name
      image.fetchPriority = isLazy ? 'low' : 'high'
      image.loading = isLazy ? 'lazy' : 'eager'
    }

    // Termék címe
    const title = productElement.querySelector('h3.product__title')

    if (title) {
      title.textContent = product.name
    }

    // Termék leírása
    const description = productElement.querySelector('p.product__description')

    if (description) {
      description.innerHTML = product.shortDescription
    }

    // Termék bruttó ára
    const grossPrice = productElement.querySelector('p.price__gross-price')

    if (grossPrice) {
      grossPrice.textContent = String.formatCurrency(product.grossPrice)
    }

    // Termék nettó ára
    const netPrice = productElement.querySelector('p.price__net-price')

    if (netPrice) {
      netPrice.textContent = `(${ String.formatCurrency(product.netPrice) } + ÁFA)`
    }

    // A termék vásárlás gombja
    const link = productElement.querySelector<HTMLAnchorElement>('a.product__button')

    if (link) {
      link.href = product.link

      // Előrendelhető vagy vásárolható a termék
      link.textContent = product.stock === 0
        ? 'Előrendelhető'
        : 'Vásárlás'
    }

    fragment.appendChild(productElement)
  })

  swiper.appendChild(fragment)

  swiper.initialize()
}
